import { render, staticRenderFns } from "./ProcessFeatures.vue?vue&type=template&id=51c5a92b"
import script from "./ProcessFeatures.vue?vue&type=script&lang=js"
export * from "./ProcessFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports